import { useEffect } from "react";
import { FAQS } from "@/data/faqs";

const BUSINESS = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "MedicalBusiness", "HealthAndBeautyBusiness"],
  name: "Sano Acupuncture",
  image: "https://nervous-system-care-1.preview.emergentagent.com/assets/sano-logo.jpg",
  url: "https://sanoacu.com",
  telephone: "+1-929-272-6066",
  email: "sanoacu@gmail.com",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: "952 Southern Blvd #202",
    addressLocality: "Bronx",
    addressRegion: "NY",
    postalCode: "10459",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 40.8245,
    longitude: -73.8901,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "09:00",
      closes: "19:00",
    },
  ],
  sameAs: ["https://www.instagram.com/sanoacupuncture"],
  founder: {
    "@type": "Person",
    name: "Joannie Campuzano Cepeda",
    jobTitle: "Licensed Acupuncturist",
    image:
      "https://nervous-system-care-1.preview.emergentagent.com/assets/joannie-portrait.jpg",
    worksFor: { "@type": "Organization", name: "Sano Acupuncture" },
  },
  medicalSpecialty: [
    "Acupuncture",
    "TraditionalChineseMedicine",
    "PainManagement",
    "WomensHealth",
  ],
};

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const PERSON = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Joannie Campuzano Cepeda",
  jobTitle: "Licensed Acupuncturist",
  worksFor: { "@type": "Organization", name: "Sano Acupuncture" },
  url: "https://sanoacu.com",
  image:
    "https://nervous-system-care-1.preview.emergentagent.com/assets/joannie-portrait.jpg",
};

/**
 * Injects all site-wide structured data (LocalBusiness, FAQ, Person) into the
 * document head. Search engines consume this for rich results & local SEO.
 */
export default function StructuredData() {
  useEffect(() => {
    const blobs = [
      { id: "ld-business", data: BUSINESS },
      { id: "ld-faq", data: FAQ_SCHEMA },
      { id: "ld-person", data: PERSON },
    ];
    blobs.forEach(({ id, data }) => {
      let s = document.getElementById(id);
      if (!s) {
        s = document.createElement("script");
        s.id = id;
        s.type = "application/ld+json";
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(data);
    });
  }, []);
  return null;
}
